import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private settings: any = {};

  constructor(private http: HttpClient) { }

  public async GetSettings(client_id: string): Promise<void> {
    console.log('getting settings...');
    this.settings = await firstValueFrom(this.http.get(`${environment.configUrl}${client_id}`));
    console.log('settings', this.settings);
  }

  public get smeasyLoginUrl(): string { return this.settings.smeasyLoginUrl || ''; }
  public get authorizationUrl(): string { return this.settings.authorizationUrl || ''; }
  public get clientDetailsUrl(): string { return this.settings.clientDetailsUrl || ''; }
  public get x_apim_key(): string { return this.settings.x_apim_key || ''; }
  public get api_auth_key(): string { return this.settings.api_auth_key || ''; }
  public get clientDisplayName(): string { return this.settings.clientDisplayName || ''; }
  public get clientImageUrl(): string { return this.settings.clientImageUrl || ''; }
  public get clientIdIsValid(): boolean { return this.settings.clientIdIsValid || false; }
  public get environment(): string { return this.settings.environment || ''; }

}
